/* TFS v18 — respect de prefers-reduced-motion sur les défilements pilotés en JS.

   Le thème appelle scrollIntoView({ behavior: 'smooth' }) à deux endroits :
   au changement de variante (pour amener la bonne photo) et à la soumission
   du formulaire sans taille choisie. La règle CSS scroll-behavior: auto ne
   couvre PAS ces appels, parce que l'option explicite gagne toujours.
   On force donc le comportement instantané quand la personne a demandé moins
   de mouvement. Aucune autre logique n'est touchée. */
(function () {
  var query = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!query || !Element.prototype.scrollIntoView) return;

  var native = Element.prototype.scrollIntoView;
  Element.prototype.scrollIntoView = function (options) {
    if (query.matches && options && typeof options === 'object' && options.behavior === 'smooth') {
      var copy = {};
      for (var key in options) { if (Object.prototype.hasOwnProperty.call(options, key)) copy[key] = options[key]; }
      copy.behavior = 'auto';
      return native.call(this, copy);
    }
    return native.apply(this, arguments);
  };
})();
